export enum InstagramConversationType {
  DM = 'dms',
}

export const INSTAGRAM_TAB_PARAM = 'tab';
